import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    // Utils
    .flex-center-main,
    .flex-center {
        justify-content: center;
    }
    .flex-center-alt,
    .flex-center {
        align-items: center;
    }
    .bold,
    strong,
    b {
        font-weight: ${props => props.theme.boldWeight};
        color: ${props => props.theme.boldTextColor};
    }
    .posrel {
        position: relative;
    }
    .hide,
    .show-mobonly,
    .hidden-pconly {
        display: none;
    }
    .show {
        display: block;
    }
    .curpt {
        cursor: pointer;
    }
    .uppercase {
        text-transform: uppercase;
    }
    .color1 {
        color: ${props => props.theme.brandPrimary};
    }
    .color2 {
        color: ${props => props.theme.brandSecondary};
    }
    .color-err {
        color: ${props => props.theme.errorColor};
    }
    .h100 {
        height: 100%;
    }
    .fakelink {
        color: ${props => props.theme.linkColor};
        font-weight: normal;

        &:focus,
        &:hover,
        &:active {
            cursor: pointer;
            text-decoration: underline;
            color: ${props => props.theme.linkHoverColor}
        }
    }
    .underline {
        text-decoration: underline;
    }
    .txtjustify {
        text-align: justify;
    }

    // SVG
    .svg-logo-foriou {
        width: 154px;
        height: 30px;
    }
    .svg-fleche {
        width: 12px;
        height: 22px;
    }
    .gauche .svg-fleche {
        transform: rotate(180deg);
    }
    .bas .svg-fleche {
        transform: rotate(90deg);
    }
    .haut .svg-fleche {
        transform: rotate(-90deg);
    }

    .svg-avatar {
        width: 20px;
        height: 20px;
    }

    .svg-loupe {
        width: 17px;
        height: 17px;
    }

    .svg-panier {
        width: 63px;
        height: 62px;
    }
    .svg-piece-euro {
        width: 82px;
        height: 82px;
    }
    .svg-portemonnaie {
        width: 67px;
        height: 64px;
    }
    .svg-copier-coller {
        width: 17px;
        height: 20px;
    }
    .svg-check {
        width: 34px;
        height: 26px;
    }

    // Select
    .select {
        position: relative;
        border-width: 1px;
        border-style: solid;
        border-radius: 3px;
        padding: 0;
        cursor: pointer;

        select {
            border: none;
            height: 100%;
            width: 100%;
            padding-right: 34px;
            font-size: 14px;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            box-shadow: none;
            background-color: transparent;
            background-image: none;
            outline: 0;
            cursor: pointer;
        }

        &:after {
            top: 6px;
            bottom: 0;
            margin: auto;
            right: 14px;
            border: solid transparent;
            content: ' ';
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
            border-color: rgba(0, 172, 229, 0);
            border-top-color: ${props => props.theme.selectDropdownArrowColor};
            border-width: 6px;
            cursor: pointer;
        }
    }

    // Main
    hr {
        margin: 40px 0;
        width: 80px;
        background: ${props => props.theme.hrBackgroundColor};
    }

    /*** Template CSS ***/
    html {
        height: 100%;
    }

    html,
    body {
        font-family: ${props => props.theme.fontStackCommon};
        font-weight: ${props => props.theme.regularWeight};
        color: ${props => props.theme.colorText};
        background-color: ${props => props.theme.backgroundBase};
        min-height: 100vh;
        overflow-x: hidden;
        width: 100%;
    }

    #root,
    #app {
        min-height: 100vh;
        overflow-x: hidden;
        width: 100%;
    }

    .conteneur {
        width: 1024px;
        margin: 0 auto;
        padding-left: 5px;
        padding-right: 5px;
    }

    a {
        color: ${props => props.theme.colorLink};

        &:focus,
        &:hover,
        &:active {
            color: ${props => props.theme.colorLinkHover};
        }
    }

    /*** main content ***/

    main.conteneur {
        margin-bottom: 60px;
    }

    /*** titre ***/

    body h1,
    body h2,
    body h3,
    h2:first-child,
    h3:first-child {
        display: block;
        font-weight: ${props => props.theme.boldWeight};
        font-family: ${props => props.theme.fontStackHeadings};
        line-height: 1;
        color: ${props => props.theme.hXColor};
        margin: 30px 0;
    }

    body h1 {
        font-size: 22px;
        margin: 40px 0;
        color: ${props => props.theme.h1Color};
        &:after {
            background: ${props => props.theme.h1BorderColor};
        }
    }

    body h2 {
        font-size: 20px;
        color: ${props => props.theme.h2Color};
        &:after {
            background: ${props => props.theme.h2BorderColor};
        }
    }

    body h1:after,
    body h2:after {
        content: '';
        display: block;
        width: 60px;
        height: 2px;
        margin: 20px 0 0;
    }

    body h3 {
        color: ${props => props.theme.h3Color};
        font-size: 15px;
    }

    .fullHeight {
        height: 100%;
    }

    // Main Tablet
    /*** seulement tablette ***/

    @media screen and (min-width: ${props => props.theme.mobile}) and (max-width: ${props =>
    props.theme.large}) {
        .show-pconly,
        .hidden-tabonly {
            display: none !important;
        }
        .hidden-pconly,
        .hidden-mobonly:not(.inbl),
        .show-tab {
            display: block;
        }
        html,
        body,
        .conteneur,
        .conteneur-mobile {
            width: 100%;
            min-width: 768px;
        }
        .conteneur,
        .entete .conteneur {
            padding-left: 20px;
            padding-right: 20px;
        }

        .cmt-ca-marche .grid-3-small-1 > div {
            width: 40%;
        }
    }

    // Main Mobile
    @media screen and (max-width: ${props => props.theme.mobile}) {
        .hidden-mobonly,
        .show-pconly {
            display: none !important;
        }
        .show-mobonly,
        .hidden-pconly {
            display: block !important;
        }
        html,
        body,
        .conteneur,
        .conteneur-mobile {
            width: 100%;
            min-width: 320px;
        }
        .conteneur {
            padding: 0;
        }
        .conteneur-mobile {
            padding-left: 20px;
            padding-right: 20px;
        }
        .txtcenter-mob {
            text-align: center;
        }

        /*** titre h2 ***/
        .h1-titre,
        .h2-titre {
            font-size: 19px;
            margin: 40px 0 30px;
        }
    }

    // Input
    .input {
        height: 100%;
        color: ${props => props.theme.colorText};
        border: 1px solid ${props => props.theme.inputBorderColor};
        padding: 10px;
        width: 100%;
        &.input-select,
        &.input-file {
            border: none;
        }
        &.input-file {
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            padding: 0;
            width: auto;
        }
    }

    .select.input-error,
    .input.input-error {
        border-color: ${props => props.theme.errorColor};
    }

    // Form
    .lockpad-label {
        margin-left: 8px;
        font-weight: bold;
    }
    select {
        cursor: pointer;
    }
    .form-success-message {
        color: ${props => props.theme.brandPrimary};
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        &.lock {
            flex-direction: column;
            .lock-label {
                margin-top: 20px;
            }
        }
    }
`;

export default GlobalStyles;



// WEBPACK FOOTER //
// ./src/style/GlobalStyles.js